<template>
  <b-card header="Perekaman Aju">
    <loading :active.sync=" this.$store.state.barpin.isLoading " :is-full-page=" false "></loading>
    <div class="row">
      <div class="col-12">
        <div class="p-3 pull-right">
          <button v-b-modal.modal-aju class="btn btn-success">
            <i class="fa fa-plus"></i> Aju Baru
          </button>
        </div>
      </div>
    </div>
    <modal-aju ref="modalAju" />
    <div>
      <table class="table table-bordered table-responsive">
        <thead>
          <tr>
            <th>No. Aju</th>
            <th>Nama</th>
            <th>Jenis Ajuan</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in aju">
            <td>{{ data.NO_AJU}}</td>
            <td>{{ data.NAMA_PENERIMA}}</td>
            <td>{{ data.JNS_AJU == '1' ? 'Barang Pindahan' : 'Kendaraan Bermotor'}}</td>
            <td>{{ data.status == null ? '' : data.status.ur_status}}</td>
            <td width="40">
              <router-link class="btn btn-primary" :to=" `perekaman/${data.NO_AJU}` ">
                <i class="fa fa-edit"></i>
              </router-link>
              <b-button variant="secondary" v-b-modal.modal-catatan @click=" getCatatan( data.ID_AJU ) "><i
                  class="fa fa-bars"></i></b-button>
              <button v-if=" data.KD_STATUS == '100' " class="btn btn-danger" @click=" removePpftz( data.ID_AJU ) ">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-catatan />
  </b-card>
</template>
<script>
import {mapActions} from 'vuex'
import ModalAju from './modal/ModalAju.vue'
import ModalCatatan from './modal/ModalCatatan.vue'
import swal from 'sweetalert'

export default {
  components: {
    ModalAju, ModalCatatan
  },
  data () {
    return {
      aju: []
    }
  },
  created () {
    this.getPpftz()
  },
  methods: {
    ...mapActions({
      getCatatan: 'barpin/getCatatan',
      removeData: 'barpin/removeData'
    }),
    getPpftz () {
      this.$store.commit('barpin/SET_LOADING', true)
      this.$http.get('ppftz/perekaman').then((response) => {
        this.aju = response.data
        this.$store.commit('barpin/SET_LOADING', false)
      })
    },
    removePpftz (id) {
      swal({
        title: 'Hapus aju ini?',
        text: 'Anda yakin akan menghapus nomor aju ini?',
        icon: 'error',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.removeData({id: id}).then(() => {
                swal('success', 'berhasil menghapus dokumen', 'success')
                this.getPpftz()
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ppftz/MenuAju.vue?5905897c